import { render, staticRenderFns } from "./SimiliarityDialog.vue?vue&type=template&id=3b56699b&"
import script from "./SimiliarityDialog.vue?vue&type=script&lang=js&"
export * from "./SimiliarityDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports